export default {
  firebase_error_codes: {
    'auth/email-already-in-use': 'The email address is already in use by another account.',
    'auth/operation-not-allowed': 'Password login is disabled for this project.',
    'auth/too-many-requests': 'We have blocked all requests from this device due to unusual activity. Try again later.',
    'auth/user-not-found': 'The user is unknown.',
    'auth/wrong-password': 'The password is invalid.',
    'auth/user-disabled': 'The user account has been disabled by the administrator.',
    'auth/expired-action-code': 'The password reset code has expired.',
    'auth/invalid-action-code': 'The password reset code is invalid. Code is malformed or has already been used.',
    'auth/user-token-expired': 'The user\'s credential is no longer valid. The user must sign in again.',
    'auth/invalid-user-token': 'An invalid refresh token is provided.',
    'auth/invalid-credential': 'The grant type specified is invalid.',
    'auth/invalid-verification-code': 'Entrez le Phone-Code',
  },
  authentication: {
    form: {
      phone: {
        label_text: 'Numéro de téléphone portable',
        additional_label_text: 'Pas de code SMS? Essayez à nouveau',
        additional_label_mobile_text: 'Pas de code SMS?',
      },
      email: {
        label_text: 'Email',
        placeholder_text: 'your@example.com',
        is_invalid_text: 'Veuillez indiquer votre adresse email.',
        label_email_text: 'Votre adresse e-mail',
      },
      password: {
        label_text: 'Mot de passe',
        additional_label_text: 'Mot de passe oublié?',
        placeholder_text: 'Veuillez saisir votre mot de passe',
        is_invalid_text: 'Ce mot de passe est incorrect.',
      },
      sign_in: {
        button_text: 'Se connecter',
        button_text_before_send_SMS: 'Demander un Phone Code',
      },
      reset_password: {
        button_text: 'Demander un nouveau mot de passe',
      },
      set_new_password: {
        button_text: 'Confirmer',
      },
    },
  },
  navigation: {
    vehicles: 'Véhicules',
    buyers: 'Acheteurs',
    profile: 'Profil',
    sms_campaign: 'Campagne SMS',
    contacts: 'Contact',
    reports: 'Rapports',
    purchased: 'Véhicules achetés',
  },
  view_titles: {
    sign_in_title_text: 'Connectez-vous avec vos identifiants.',
    sign_in_title_small_text: 'Si vous n’avez pas encore de compte, envoyez nous une demande a l’adresse suivante info@autodrop.ch',
    reset_password_title_text: 'Pour changer de mot de passe veuillez saisir votre adresse email',
    set_new_password_title_text: 'Saisissez votre nouveau mot de passe ci-dessous.',
    dashboard_title_text: 'Tous les véhicules',
    dashboard_purchased_title_text: 'Tous les véhicules achetés',
    buyer_title_text: 'Acheteurs',
    user_profile_title_text: 'Profil',
    add_vehicle_title_text: 'Ajouter un véhicule',
    edit_vehicle_title_text: 'Modifier le véhicule',
    add_buyer_title_text: 'Ajouter un acheteur',
    bids_view_title_text: 'Enchère',
    sms_campaign_title_text: 'Campagne SMS',
    add_sms_campaign_title_text: 'Ajouter une campagne SMS',
    edit_sms_campaign_title_text: 'Modifier campagne SMS',
    contacts_title_text: 'Contacts',
    add_contact_list_title_text: 'Ajouter une liste',
    contacts_list_title_text: 'Liste de contact',
    add_contact_title_text: 'Ajouter un contact',
    vehicle_preview_title_text: 'Aperçu du véhicule',
    team_members_title_text: 'Team',
    reports_title_text: 'Rapports',
    reports_add_title_text: 'Ajouter un rapport',
    vehicle_main_image_text: 'Image principale',
  },
  buyer_group: {
    form: {
      name: {
        label: 'Käufergruppe name',
        placeholder: 'par exemple: BMW Käufergruppe',
      },
      error_message: 'Veuillez entrer un nom de groupe',
    },
    list: {
      no_buyer_list: 'Pas encore de groupe d\'acheteurs',
      buyer_list_not_available_for_the_slave_account: 'Veuillez contacter votre superviseur si vous souhaitez proposer un nouvel acheteur',
    },
  },
  loading_status: {
    wait: 'Veuillez patienter...',
  },
  buyer: {
    form: {
      name: {
        label: 'Nom',
        placeholder: 'Entrez votre nom',
      },
      phone_number: {
        label: 'Numéro de téléphone',
        placeholder: '+41 00 000 00 00 ou +49 000 0000000',
      },
      email_address: {
        label: 'Email',
        placeholder: 'Entrez votre e-mail',
      },
      description: {
        label: 'Annotations',
        placeholder: 'Annotations',
      },
      loading_label: '@:loading_status.wait',
      error_messages: {
        name: 'Veuillez entrer un nom',
        phone_number: 'Veuillez entrer un numéro de téléphone valide',
      },
    },
    list: {
      main_title: 'Acheteur',
      singular_label: 'Acheteur',
      plural_label: 'Acheteurs',
      no_buyers: 'Pas encore d\'acheteurs',
    },
    add: {
      main_title: 'Ajouter un acheteur',
    },
    edit: {
      main_title: 'Sauvegarder l\'acheteur',
    },
    delete: {
      main_action: 'Supprimer',
      cancel: 'Annuler',
      main_title: 'Voulez-vous vraiment supprimer cet acheteur?',
    },
  },
  user_profile: {
    my_account_text: 'Mon compte',
    sign_out_text: 'Se déconnecter',
    support_text: 'Besoin d’aide?',
    change_name_label_text: 'Nom & Prénom',
    change_name_placeholder_text: 'Veuillez saisir le nouveau nom',
    add_name: 'Veuillez entrer votre nom',
    add_company_name: 'Veuillez saisir votre société',
    change_company_name: 'Nom de la société',
    change_password_placeholder_text: 'Entrez votre nouveau mot de passe',
    error_message_username_text: 'Saisissez un nom.',
    error_message_incorrect_address: 'Veuillez fournir l\'adresse correcte',
    error_message_new_username_text: 'Saisissez un nouveau nom.',
    select_language_label_text: 'Préférence de langue',
    select_language_placeholder_text: 'Sélectionner votre langue de prédilection',
    language_saved_text: 'Langue enregistrée',
    name_saved_text: 'Votre nom a été enregistré',
    password_saved_text: 'Votre mot de passe a été enregistré',
    address_saved_text: 'Votre adresse a été enregistrée',
    type_cars_saved_text: 'Votre type de voiture a été sauvé',
    option_saved_text: 'Option sauvegardée',
    additional_options_text_seller: 'Paramètres supplémentaires',
    additional_options_text_buyer: 'Je suis intéressé par',
    allow_bid_deletion_label_text: 'Permettre à l\'acheteur d\'annuler son offre.',
    allow_bid_modification_label_text: 'Permettre à l\'acheteur de modifier son offre.',
    bidding_completion_email_label: 'Email après la vente',
    option_car: 'Car',
    option_truck: 'Camion',
    option_car_truck: 'Camion et voiture',
    add_address_field_label: 'Veuillez ajouter votre adresse',
    change_address_field_placeholder: 'Veuillez saisir votre nouvelle adresse',
    change_address_field_label: 'Changement d\'adresse',
    change_address_field_text: 'Vous êtes sûr de vouloir mettre à jour votre adresse ?',
    change_password_field_label: 'Changer votre mot de passe  ',
    verified_phone_number: 'Votre numéro de téléphone',
  },
  buyers_view: {
    buyers_pool_text: 'Liste des acheteurs',
    add_buyer_text: 'Ajouter un acheteur',
    confirm_buyer_delete_text: 'Voulez vous vraiment supprimer cet acheteur?',
    empty_list_text: 'Vous n’avez pas d’acheteur dans votre liste',
  },
  sms_campaign_view: {
    sms_campaign_active_text: 'Liste des campagnes SMS- Active(s)',
    sms_campaign_archived_text: 'Liste des campagnes SMS- Archivée(s)',
    sms_campaign_starting_date_text: 'Date d’envoi: ',
    add_sms_campaign_text: 'Ajouter une campagne SMS',
    sms_campaign_delete_text: 'Voulez vous vraiment supprimer cette campagne?',
    sms_campaign_status_draft_text: 'Brouillon',
    sms_campaign_status_ready_to_send_text: 'Prêt pour l’envoi',
    sms_campaign_status_archived_text: 'Archivé(es)',
    sms_campaign_status_in_progress_text: 'Envoi en cours',
  },
  contacts_view: {
    title_text: 'Liste des contacts',
    add_list_text: 'Ajouter une liste',
    confirm_list_delete_text: 'Voulez vous vraiment supprimer cette liste?',
  },
  contacts_list_view: {
    add_contact_text: 'Ajouter un contact',
    confirm_contact_delete_text: 'Voulez vous vraiment supprimer ce contact?',
    more_contacts_text: 'Vous avez plus de contacts...',
  },
  vehicle_expired: {
    expired_text: 'Cette offre a expiré',
    wait_another_offer_or_visit_link: 'Veuillez attendre la prochaine offre ou visiter:',
    interested_in_more_offers_text: 'Vous êtes intéressé par d\'autres offres de véhicules?',
    more_about_text: 'En savoir plus sur',
    your_last_offer_was: 'Votre dernière enchère était',
  },
  contact_list_form: {
    list_name_text: 'Nom de la liste:',
    list_name_placeholder_text: 'Saisissez le nom de la liste',
    add_list_text: 'Ajouter une  liste',
  },
  contact_form: {
    first_name_text: 'Prénom:',
    first_name_placeholder_text: 'Saisissez le nom',
    last_name_text: 'Nom:',
    last_name_placeholder_text: 'Saisissez le nom',
    phone_number_text: 'Numéro de téléphone:',
    phone_number_placeholder_text: 'Saisissez le Numéro de téléphone:',
    add_contact_text: 'Ajouter contact',
  },
  sms_campaign_form: {
    sms_campaign_name_text: 'Nom: ',
    sms_campaign_name_placeholder_text: 'Saisissez le nom de la campagne',
    sms_campaign_date_text: 'Date d’envoi:',
    sms_campaign_starting_time_text: 'Heure d’envoi: ',
    sms_campaign_message_placeholder_text: 'Veuillez saisir votre message',
    sms_campaign_message_length_text: 'Longueur du message: ',
    sms_campaign_save_message_text: 'Enregistrer le message',
    fetching_list_text: 'Veuillez patienter...',
  },
  dashboard: {
    add_vehicle_text: 'Ajouter un véhicule',
    vehicle_status_text: {
      active_vehicle_concrete_text: 'Laufende',
      archived_vehicle_concrete_text: 'Abgelaufene',
      extended_text: 'véhicules',
      shorthand_text: 'FZ',
      active_vehicle_extended_text: '@:dashboard.vehicle_status_text.active_vehicle_concrete_text @:dashboard.vehicle_status_text.extended_text',
      active_vehicle_shorthand_text: '@:dashboard.vehicle_status_text.active_vehicle_concrete_text @:dashboard.vehicle_status_text.shorthand_text',
      archived_vehicle_extended_text: '@:dashboard.vehicle_status_text.archived_vehicle_concrete_text @:dashboard.vehicle_status_text.extended_text',
      archived_vehicle_shorthand_text: '@:dashboard.vehicle_status_text.archived_vehicle_concrete_text @:dashboard.vehicle_status_text.shorthand_text',
    },
    no_active_vehicle_text: 'Vous n’avez pas de véhicule actif.',
    no_archived_vehicle_text: 'Pas de véhicule trouvé.',
    highest_bid_text: 'Enchère la plus haute:',
    no_bids_text: 'Aucune offre',
    vehicle_card_text: {
      online_in_text: 'Publié dans',
      days_text: 'jour | jours',
      online_today_text: 'Publié aujourd\'hui',
    },
  },
  vehicle_form: {
    select_at_least_one_buyer_group: 'Veuillez sélectionner au moins un groupe d\'acheteurs.',
    unsaved_changes: 'Le véhicule n\'est pas enregistré, voulez-vous vraiment quitter la page?',
    make_placeholder_text: 'Veuillez sélectionner la marque',
    model_placeholder_text: 'Veuillez sélectionner le modèle',
    version_placeholder_text: 'Veuillez saisir la version',
    mileage_placeholder_text: 'Veuillez saisir le nombre de Kms',
    body_type_placeholder_text: 'Veuillez  sélectionner le type de carrosserie',
    registration_date_placeholder_text: 'Veuillez sélectionner la date de régistration',
    last_inspection_date_placeholder_text: 'Veuillez sélectionner la date de la dernière expertise',
    fuel_type_placeholder_text: 'Veuillez sélectionner le type de carburant',
    gear_type_placeholder_text: 'Veuillez sélectionner la boîte de vitesses',
    engine_power_placeholder_text: 'Veuillez saisir la puissance moteur',
    engine_capacity_placeholder_text: 'Veuillez saisir la cylindrée',
    notes_placeholder_text: 'Commentaire complémentaire',
    select_vehicle_card_id_text: 'Sélectionner',
    to_image_upload_text: 'Vers l’upload de l’image',
    select_images_text: 'Sélectionnez des images',
    selected_images_text: 'Images du véhicules',
    image_upload_hint_1_text: 'Vous pouvez également uploader les photos du livret de service / évaluation du véhicule (Eurotax, Auto-i-dat).',
    image_upload_hint_2_text: 'Pour obtenir le meilleur prix, nous recommandons d\'uploader 7 à 10 photos.',
    back_to_details_text: 'Retour vers les détails',
    add_vehicle_text: 'Publier véhicule',
    save_vehicle_text: 'Enregistrer le véhicule',
    extras_text: 'Caractéristiques (Optionnel)',
    internal_number_placeholder_text: 'Par exemple les 8 derniers caractères',
    loading_images_text: 'Les images sont chargées',
    vehicle_data_title: 'Données du véhicule',
    buyer_pool_collapse_title: 'Groupes d\'acheteurs',
    available_right_away_text: 'Immédiatement',
    choose_date_text: 'Choisissez la date',
  },
  vehicle_details: {
    valid_until_text: 'En ligne jusqu\'au',
    mfk_text: 'Dernière expertise',
    place_your_bid_text: 'Faire une offre',
    modify_your_bid_text: 'Modifier votre offre: ',
    confirm_button_text: 'Confirmer',
    cancel_button_text: 'Annuler',
    remove_your_bid_text: 'Annuler votre offre',
    remove_your_bid__question_text: 'Voulez vraiment annuler votre offre',
    open_document_text: 'Ouvrir le document',
    is_no_warranty_explanation_text: 'Toute garantie, dans la mesure requise par la loi, est levée. En particulier, le droit à une réduction de prix ou à la résolution du contrat.',
    vehicle_text_scheduled: 'Prévu pour être mis en ligne sur',
    is_checked_text: 'Oui',
    is_not_checked_text: 'Non',
    bid_is_too_low_text: 'Votre enchère n\'est pas suffisante, veuillez l\'augmenter afin de participer.',
    enter_your_bid_first_text: 'Veuillez saisir votre prix en',
    enter_your_bid_last_text: '(exemple: 7500).',
    your_bid_is_text: 'Votre offre est',
    confirm_bid_text: 'Êtes-vous sûr de vouloir faire une offre pour ce véhicule?',
    available_right_away_text: 'Immédiatement',
    error_message_buyer_name: 'Pour faire des offres de voitures, veuillez mettre à jour votre nom et votre adresse sous le "Profil", une fois que le nom et l\'adresse sont définis, veuillez vérifier à nouveau ici',
  },
  to_contact_form_text: 'Prendre contact',
  home_view: {
    welcome_text: 'Bienvenue sur AutoDrop!',
    sell_car_per_sms_text: 'La plateforme qui vous permet de vendre vos véhicules par SMS',
    thanks_for_email_text: 'Nous avons bien reçu vos données. Nous vous contacterons le plus vite possible.',
    want_know_more_text: 'Vous souhaitez en savoir plus sur AutoDrop?',
    enter_email_placeholder_text: 'Saisissez votre adresse e-mail',
    send_email_button_text: 'Envoyer',
    already_have_account_text: 'Possédez vous déjà un compte AutoDrop?',
    to_login_button_text: 'Se connecter',
    enter_valid_name_text: 'Veuillez saisir un nom valable.',
    enter_valid_phone_text: 'Veuillez indiquer un numéro de téléphone valable.',
    enter_valid_email_text: 'Veuillez saisir une adresse email valide.',
    price_text: 'Tarif',
    login_text: 'Se connecter',
    b2b_title_text: 'Plateforme d\'enchères B2B pour les véhicules d\'occasion',
    subtitle_long_text: 'Sur Autodrop, les concessionnaires automobiles peuvent facilement ajouter leurs véhicules et les proposer à la vente par SMS/WhatsApp. Des groupes d\'acheteurs sélectionnés reçoivent des offres de concessionnaires vérifiés et donnent leur meilleur prix.',
    subtitle_short_text: 'La solution pour une situation Win-Win dans le secteur de l’automobile!',
    buy_vehicle_title_text: 'Achat de véhicule',
    buy_vehicle_subtitle_text: 'Recevez par SMS des véhicule à vendre chez des concessionaire certifiés, et proposez leur votre meilleur prix.',
    read_more_text: 'En savoir plus',
    read_more_route_name: 'SellerInformationFR',
    sell_vehicle_title_text: 'Vente de véhicules',
    sell_vehicle_subtitle_text: 'Vendez vos véhicules par SMS à des professionels sélectionnés pour obtenir la meilleure offre.',
    contact_form_title_text: 'Formulaire de contact',
    i_want_to_text: 'Je souhaite',
    i_want_to_buy_vehicle_text: 'acheter des véhicules',
    i_want_to_sell_vehicle_text: 'vendre des véhicules',
    i_want_to_buy_vehicle_new_text: 'Si vous souhaitez acheter des voitures, il vous suffit de vous',
    i_want_to_buy_vehicle_new_link_text: 'connecter ici',
    name_placeholder_text: 'Jean-Jacques',
    company_name_placeholder_text: 'Garage SA/Sàrl',
    phone_placeholder_text: '+41 00 000 00 00',
    email_placeholder_text: 'votre@email.com',
    name_label_text: 'Nom', // NEW
    company_name_label_text: 'Nom de l\'entreprise',
    phone_label_text: 'Numéro de portable',
    phone_second_label_text: 'avec SMS / WhatsApp',
    email_label_text: 'Email',
    advantages_text: 'Atouts',
    first_advantage_text: 'Capturez votre véhicule en une minute avec votre smartphone.',
    second_advantage_text: 'Dans 24 heures, votre véhicule trouvera son acheteur.',
    third_advantage_text: 'Transparence dans toute l\'unité de vente du concessionnaire automobile.',
    last_offers_text: 'Derniers véhicules de notre marché B2B',
    choose_checkbox: 'Veuillez choisir si vous voulez vendre ou acheter des voitures !',
  },
  buyer_read_more_view: {
    steps_for_buying_vehicle_title_text: 'Vos étapes pour faire du shopping',
    first_step_title_text: 'Formulaire de contact',
    first_step_explanation_text: 'Souhaitez-vous participer aux ventes aux enchères de véhicules de n\'importe où ? Alors remplissez notre formulaire de contact et devenez membre du pool d\'acheteurs AutoDrop. L\'adhésion est gratuite pour vous!',
    second_step_title_text: 'Offres commerciales',
    second_step_explanation_text: 'Recevez les offres de vente des concessionnaires automobiles de confiance par SMS. Dans le lien ci-joint, vous trouverez des photos avec des descriptions détaillées des véhicules.',
    third_step_title_text: 'Votre offre',
    third_step_explanation_text: 'Ça vous intéresse ? Alors faites votre meilleure offre dans les 24 heures ! Le statut de l\'enchère n\'est pas affiché, mais vous pouvez augmenter votre enchère à tout moment. Chaque offre est contraignante et doit être réaliste.',
    fourth_step_title_text: 'Acheter',
    fourth_step_explanation_text: 'Si votre offre était la meilleure, le concessionnaire vous contactera par téléphone ou par courriel pour discuter des prochaines étapes.',
  },
  seller_read_more_view: {
    steps_for_selling_vehicle_title_text: 'Comment vendre vos véhicules? C’est très simple',
    first_step_title_text: 'Adhésion',
    first_step_explanation_text: 'Remplissez notre formulaire de contact et nous organiserons une démonstration gratuite d\'Autodrop.',
    second_step_title_text: 'Groupe d\'acheteurs',
    second_step_explanation_text: 'Sélectionnez vos acheteurs potentiels en fonction de vos propres critères (proximité, confiance, etc.). Une fois que votre groupe d\'acheteurs a été saisi, il peut participer à votre enchère.',
    third_step_title_text: 'Vente aux enchères',
    third_step_explanation_text: 'Dès que votre véhicule est immatriculé, votre groupe d\'acheteurs reçoit un SMS et peut enchérir dans les 24 heures, que vous pouvez suivre à tout moment. Ces enchères ne sont visibles que pour vous afin d\'éviter toute collusion ou fraude.',
    fourth_step_title_text: 'Vente',
    fourth_step_explanation_text: 'Choisissez la meilleure offre et contactez l\'acheteur pour discuter des prochaines étapes. Les véhicules invendus sont archivés et peuvent être de nouveau mis aux enchères à tout moment. Vous êtes libre d\'ajouter de nouveaux acheteurs à votre liste pour augmenter vos chances.',
  },
  price_list_view: {
    price_intro_title_text: 'Des prix simples et justes',
    price_intro_subtitle_text: 'Nous avons le coût de vente de voitures d\'occasion le plus bas de l\'industrie.',
    free_tryout_subtitle_text: 'Téléchargez gratuitement autant de véhicules que vous le souhaitez pendant un mois. Vous ne payez que les frais de Notification SMS.',
    sms_fee_title_text: 'Tarif par SMS',
    sms_fee_subtitle_text: '*max. 160 caractères',
    upload_vehicle_title_text: 'Publier un véhicule',
    upload_vehicle_subtitle_text: 'par véhicule',
    monthly_bill_explanation_text: 'À la fin de chaque mois, vous recevrez une facture avec une facture avec toute les transactions par courrier électronique.',
    buyer_text: 'Acheteur',
    seller_text: 'Vendeur',
    signin_seller_text: 'Vendeur',
    signin_buyer_text: 'Acheteur',
    free_auto_drop_text: 'Utilisateur AutoDrop gratuit',
    free_auto_drop_subtitle_text: 'Tous les services sont gratuits pour les acheteurs.',
    logo_title_text: 'Votre logo',
    logo_subtitle_text: 'Frais de mise en place uniques',
    own_sender_name_title_text: 'Votre nom comme expéditeur',
    own_sender_name_subtitle_first_text: 'Frais de mise en place uniques, ensuite 10',
    own_sender_name_subtitle_last_text: 'par mois',
    whatsapp_title_text: 'AutoDrop pour WhatsApp',
    whatsapp_subtitle_first_text: '10',
    whatsapp_subtitle_last_text: 'par mois',
    more_questions_text: 'Vous avez d\'autres questions? Il suffit d\'appeler le +41 32 511 10 44 ou d\'écrire un e-mail à info@autodrop.ch.',
    free_text: 'Gratuit',
  },
  vehicle_preview: {
    version_label_text: 'Version',
    make_label_text: 'Marque',
    model_label_text: 'Modèle',
    enginePower_label_text: 'Puissance du moteur',
    engineCapacity_label_text: 'Cylindrée',
    availableFrom_label_text: 'Disponible à partir de',
    bodyType_label_text: 'Aufbauart',
    fuelType_label_text: 'Carburant',
    gearboxType_label_text: 'Boîte de vitesses',
    isNoWarranty_label_text: 'Ab Platz / Ohne Garantie',
    isServiceDone_label_text: 'Service réalisé',
    isSummerWinterTyreSetAvailable_label_text: 'Pneus été et hiver',
    isTwoKeysAvailable_label_text: 'Paire de clés disponible',
    isFourWheelDrive_label_text: '4 roues motrices',
    isVehicleNotReadyToDrive_label_text: 'FZ ist nicht fahrbar',
    mileage_label_text: 'Kilométrage',
    notes_label_text: 'Description',
    bids_title_text: 'Offres',
    no_bids_title_text: 'Aucune offre pour le moment',
    vehicle_details_title_text: 'Détails du véhicule',
    vehicle_send_again_text: 'Souhaitez-vous relancer ce véhicule ?',
    vehicle_send_again_button_text: 'Envoyer à nouveau',
    vehicle_send_again_cancel_button_text: 'Abbrechen',
    vehicle_send_again_warning_text: 'Souhaitez-vous relancer ce véhicule à tous les acheteurs? Veuillez noter que les frais de SMS seront facturés.',
    bidding_ends_in_text: 'Endet in',
    internalNumber_label_text: 'Numéro de la voiture',
    call_the_highest_bidder_text: 'Veuillez contacter le plus offrant pour compléter la transaction.',
    created_on_text: 'Créé le',
    statistics_text: 'Statistiques',
    visits_text: 'Visites',
  },
  reports: {
    report_type_option_vehicles: 'Véhicules',
    report_type_option_sellers: 'Vendeurs',
    report_name_label_text: 'Nom du rapport',
    report_name_placeholder_text: 'Entrer le nom du rapport',
    report_start_date_label_text: 'Date de début',
    report_start_date_placeholder_text: 'Sélectionner la date de début',
    report_end_date_label_text: 'Date de fin',
    report_end_date_placeholder_text: 'Sélectionner la date de fin',
    report_type_label_text: 'Sélectionner le type de rapport',
    report_type_placeholder_text: 'Sélectionner le type de rapport',
    report_save_button_text: 'Sauvegarder le rapport',
    report_download_button_text: 'Télécharger',
    your_first_report_text: 'Ajouter votre premier rapport',
    generating_report_text: 'Création du rapport..',
    report_type_sellers_text: 'Vendeurs',
    report_type_vehicles_text: 'Véhicules',
    delete_report_question_text: 'Souhaitez-vous supprimer ce rapport?',
    delete_report_cancel_button_text: 'Annuler',
    delete_report_confirm_delete_button_text: 'Supprimer',
    reports_initial_loading_text: 'Chargement',
    reports_add_title_text: 'Créer un rapport',
    generation_failed: 'La génération a échouée',
  },
  actions: {
    add: 'Ajouter',
    back_to_vehicles: 'Retourner aux véhicules',
    edit: 'Modifier',
    reload_page: 'Recharger la page',
    save: 'Sauvegarder',
    show: 'Afficher',
  },
  bids: {
    plural_rules: 'enchère | enchères',
    ends: 'Termine',
    starts: 'Commence',
  },
  buyer_group_new: {
    // Note: https://kazupon.github.io/vue-i18n/guide/pluralization.html#pluralization
    plural_rules: 'Groupe d\'acheteurs | Groupes d\'acheteurs',
    global: {
      plural_rules: 'Groupe d\'Autodrop | Groupes d\'Autodrop',
    },
    owned: {
      plural_rules: 'Groupe personnel | Groupes personnels',
    },
    actions: {
      add: '@:(actions.add) groupe d\'acheteurs',
      edit: '@:(actions.edit) groupe d\'acheteurs',
      confirm_deletion: 'Êtes-vous sûr de vouloir supprimer ce groupe d\'acheteurs?',
    },
  },
  error: {
    loading: 'Erreur pendant le chargement, réessayer ultérieurement.',
  },
  form: {
    select_value: 'Sélectionner',
    enter_value: 'Entrez la valeur',
    optional_label: '- Optional',
  },
  not_allowed: {
    to_see_this_type_of_vehicle: 'Vous n\'êtes pas autorisé à voir ce type de véhicule.',
    to_see_vehicle: 'Vous n\'êtes pas autorisé à voir ce véhicule.',
  },
  online: 'En ligne',
  short: {
    cubic_centimetre: 'ccm',
    horsepower: 'CV',
    kilowatt: 'kW',
  },
  status: {
    selected: {
      plural_rules: 'sélectionné | sélectionnés',
    },
    none_selected: 'Aucun sélectionné',
  },
  vehicle: {
    plural_rules: 'Véhicule | Véhicules',
    localized_data_order: ['data', 'vehicle.plural_rules'],
    localized_photos_order: ['photos', 'vehicle.plural_rules'],
    available_from: 'Disponible à partir de',
    axe_type: 'Configuration des essieux',
    body_type: 'Type de la carrosserie',
    emission_type: 'Norme d\'émission',
    engine_capacity: 'Cylindrée',
    engine_capacity_ccm: 'Cylindrée (@:(short.cubic_centimetre))',
    engine_power: 'Puissance moteur',
    engine_power_kw: 'Puissance moteur (@:(short.kilowatt))',
    fuel_type: 'Type du carburant',
    gearbox_type: 'Boîte de vitesses',
    general_condition: 'État général du véhicule',
    id_document: 'Carte grise',
    interior: 'Intérieur',
    internal_number: 'Numéro interne',
    last_inspection_date: 'Date de la dernière visite technique',
    make: 'Marque',
    mileage: 'Kilométrage',
    model: 'Modèle',
    notes: 'Commentaires',
    notes_optional: 'Commentaires (Optionnel)',
    registration_date: 'Date de mise en circulation',
    tachometer: 'Compteurs',
    tires_condition: 'État des pneus',
    valid_until: 'Gültig bis',
    version: 'Version/Type',
    actions: {
      add: '@:(actions.add) véhicule',
      edit: '@:(actions.edit) véhicule',
      save: '@:(actions.save) véhicule',
    },
    options: {
      four_wheel_drive: '4 roues motrices',
      no_warranty: 'Aucune garantie',
      not_ready_to_drive: 'Le véhicule est inconduisible',
      summer_winter_tyre_set_available: '2 jeux de pneus',
      service_done: 'Service effectué',
      two_keys_available: '2 clés',
    },
    status: {
      is_being_sent: 'En cours d\'envoi',
    },
  },
  front: 'Avant',
  back: 'Arrière',
  left: 'Gauche',
  right: 'Droite',
  main_picture: 'Image principale',
  data: 'Données',
  photos: 'Images',
  publication_date: 'Date de publication',
  round: 'Tour',
  sending_options: 'Options d\'envoi',
  active: {
    plural_rules: 'Actif | Actifs',
  },
  archived: {
    plural_rules: 'Archivé | Archivés',
  },
  no_vehicles_created_yet: 'Vous n\'avez pas encore créer de véhicule.',
  no_vehicles_yet: 'Vous n\'avez pas encore de véhicules.',
  no_archived_vehicles: 'Vous n\'avez aucun véhicule archivé.',
  no_vehicles_for_buyer: 'Pour l\'instant, nous n\'avons pas de véhicules, sorry :(',
  update_button_text: 'au Profil',
  need_help_button_text: 'Besoin de support ?',
  no_active_and_name_buyer_text: 'Votre compte n\'est pas encore actif, veuillez indiquer votre nom et votre adresse afin que nous puissions le vérifier. Nous vous informerons dès qu\'il sera prêt !',
  no_active_buyer_text: 'Votre compte est en cours de vérification.',
  no_confirmed_purchased_vehicles: 'Les véhicules achetés seront présentés ici après que le vendeur aura confirmé la vente',
  all_vehicles: 'Tous les véhicules',
  create_vehicle: 'Ajouter',
  vehicle_is_being_added: 'Ajout du véhicule..',
  language_display_names: {
    de: 'Allemand',
    fr: 'Français',
    en: 'Anglais',
  },
};
